import { createFileRoute } from '@tanstack/react-router'
import EmailTemplateList from 'Administration/components/royalty/emailTemplate/EmailTemplateList'

import AdministrationPage from '../-administrationPage'
import { Guard } from '../-guard'

export const Route = createFileRoute('/administration/emailtemplates')({
    component: () => (
        <Guard claims={['opus_royalty']}>
            <AdministrationPage>
                <EmailTemplateList />
            </AdministrationPage>
        </Guard>
    ),
})
